export interface ShipmentDocument {
  state: ShipmentDocumentState;
  url?: string;
}

export enum ShipmentDocumentState {
  NOT_AVAILABLE,
  EXPIRED,
  VALID,
  RETURNED,
}
